import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import MobileMenu from 'dpl/components/MobileMenu';
import SortDropdown from 'dpl/puppy_search_results/components/SortDropdown';
import MobileFilterMenuV2 from 'dpl/search_result_filters/components/MobileFilterMenu';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

import SearchFilters from './SearchFilters';
import FilterDrawer from './FilterDrawer';

export default function MobileFilterMenu({
  shouldShowSort,
  isMenuOpen,
  setIsMenuOpen,
  totalItemCount
}) {
  const IS_SEARCH_FILTERS_REDESIGN_ENABLED = isFeatureEnabled(
    FEATURES.SEARCH_FILTERS_REDESIGN
  );

  if (IS_SEARCH_FILTERS_REDESIGN_ENABLED) {
    return (
      <MobileFilterMenuV2
        shouldShowSort={shouldShowSort}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        totalItemCount={totalItemCount}
      />
    );
  }
  return (
    <>
      <div
        className={classnames(
          'scrim--black fixed z-max left-0 top-0 right-0 bottom-0 transition pointer-events-none',
          {
            'o-0': !isMenuOpen,
            'o-100': isMenuOpen
          }
        )}
      />
      <MobileMenu
        className="pt6 no-scrollbars"
        position="bottom"
        isOpen={isMenuOpen}
      >
        <div className="MobileFilterMenu flex flex-column bg-white min-h-100 overflow-y-auto">
          <div className="bb br--top b--light-gray flex br3 justify-between fw-medium pt6 pb4 ph4 mb8">
            <button
              type="button"
              onClick={() => setIsMenuOpen(false)}
              data-test-id="mobileFiltersToggleOff"
              className="gray f2"
            >
              Close
            </button>
            <p>{shouldShowSort ? 'Sort & filter' : 'Filter results'}</p>
            <button
              type="button"
              className="purple f2"
              onClick={() => setIsMenuOpen(false)}
            >
              Apply
            </button>
          </div>
          {shouldShowSort && (
            <FilterDrawer
              className="PuppySearchResultsSortDropdown"
              title="Sort"
            >
              <SortDropdown className="f3 fw-normal" />
            </FilterDrawer>
          )}
          <SearchFilters />
        </div>
      </MobileMenu>
    </>
  );
}

MobileFilterMenu.propTypes = {
  isMenuOpen: PropTypes.bool,
  shouldShowSort: PropTypes.bool,
  setIsMenuOpen: PropTypes.func.isRequired,
  totalItemCount: PropTypes.number.isRequired
};

MobileFilterMenu.defaultProps = {
  isMenuOpen: false,
  shouldShowSort: false
};
